import { Pipe, PipeTransform } from '@angular/core';
import { TourneeModel } from '../models/tournee.model';
import { SaleService } from '../services/sale/sale.service';

@Pipe({ name: 'address',pure:false })
export class AddressPipe implements PipeTransform {
  constructor(private saleService:SaleService){

  }
  transform(sale: TourneeModel) {
    // let address = (this.saleService.showDeliveryPlaceName(details.deliveryType) && details.geocoding.address?.name)
    //   ?(details.geocoding.address?.name+', '):'';
    // if(showFullAddress) address+= details.geocoding.label
    // else address += details.geocoding.resultType=='houseNumber'?(details.geocoding.address.houseNumber + ', ' + details.geocoding.address.street):details.geocoding.address.street
    // return address;
    return this.saleService.getPlacesSummaryLabel(sale);
  }
}